import { InspectButtonStatus } from "@/model/InspectButtonStatus";
import { InspectButtonValue } from "@/model/InspectButtonValue";
import { InspectItem, InspectValueItem } from "@/model/InspectItem";
import { NAVIGATION_STATUS } from "@/model/NavigationStatus";
import ButtonInspectGroup from "@/components/common/button/ButtonInspectGroup.vue";
import { STATUS_SELECT_WORK_BUHIN } from "@/model/StatusSelectWorkBuhin";
import { Work } from "@/model/Work";
import { deepCopy } from "@/service/util";
import {
  InspectRecommendSubItem,
  InspectRecommendCategory
} from "@/model/InspectRecommend";
import { BuhinDetail } from "@/model/Buhin";
import { INSPECT_VALUE_VIEW_TYPE, INSPECT_VALUE_LENGTH } from "@/model/InspectValueViewType";
import { CarSelectData } from '@/model/CarSelection';
import { InspectGenshaSubItem } from "@/model/InspectGensha";
import {
  InspectGenshaCategory,
  InspectDescriptions
} from "@/model/InspectGensha";
export class inspectService {
  findIndexOnScreen() {
    let start = -1;
    let end = -1;
    const rows = document.querySelectorAll(".div-row");
    if (rows.length > 0) {
      const n = rows.length;
      for (let i = 0; i < n; i++) {
        const isOn = this.isOnScreen(i);
        if (start == -1 && isOn) {
          start = i;
        }
        if (start > -1 && !isOn) {
          end = i - 1;
          break;
        } else {
          end = i;
        }
      }
    }
    return { start, end };
  }

  isOnScreen(index: number) {
    const element = document.getElementById(`div-row-${index}`);
    const container = document.querySelector(".select-item-wrap");
    if (container && element) {
      const containerBound = container.getBoundingClientRect();
      const elementBound = element.getBoundingClientRect();
      const curTop = elementBound.top;
      const curBottom = elementBound.bottom;
      const containerTop = containerBound.top + 10;
      const containerBottom = containerBound.bottom - 30;
      return curTop >= containerTop && curBottom <= containerBottom;
    }
    return false;
  }

  setInspectResult(value: number, item: InspectDescriptions) {
    item.inspectResult = value;
    if (value == InspectButtonValue.CIRCLE) {
      item.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      // this.deletAllBuhinInSebi(item.seibiList);
    } else if (item.seibiList.length == 0 && item.manualSeibiList.length == 0) {
      item.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
    } else if (item.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.NoNeed) {
      item.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
    }
  }

  removeDefualtBuhin(buhinList: any) {
    return buhinList.filter((b: BuhinDetail) => b.id);
  }

  deletAllBuhinInSebi(seibiList: any[]) {
    seibiList.forEach(seibi => {
      seibi.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
      seibi.buhinList = this.removeDefualtBuhin(seibi.buhinList);
      seibi.buhinList.forEach((buhin: BuhinDetail) => {
        if (buhin.id) {
          buhin.isDelete = 1;
        }
      });
      if (seibi.osusumeBuhinList) {
        seibi.osusumeBuhinList = this.removeDefualtBuhin(seibi.osusumeBuhinList);
        seibi.osusumeBuhinList.forEach((buhin: any) => {
          if (buhin.id) {
            buhin.isDelete = 1;
          }
        });
      }
    });
  }

  setInspectResultRecomend(value: number, item: InspectRecommendSubItem) {
    item.inspectResult = value;
    if (value == InspectButtonValue.CIRCLE) {
      item.buhinSelected = STATUS_SELECT_WORK_BUHIN.NoNeed;
      // this.deletAllBuhinInSebi([item]);
    } else if (item.buhinSelected == STATUS_SELECT_WORK_BUHIN.NoNeed) {
      item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
    }
  }

  setInspectResultRecomend2(value: number, item: InspectRecommendSubItem) { // Recommend
    item.inspectResult = value;
  }

  changeStatus(item: InspectDescriptions, isInit = false) {
    // 2022-01-31 morisako kobac-free mod [START]
    // const seibi = item.seibiList.find((e: any) => e.seibiId != null);
    const seibi = item.seibiList.find((e: any) => e.seibiId != null && e.isDiscount != 1);
    // 2022-01-31 morisako kobac-free mod [END]
    if (isInit && seibi && item.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Initial) {
      seibi.disabledSave = true;
      item.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
    }
    if (item.inspectResult == InspectButtonValue.CIRCLE) {
      if (this.checkInspectValue(item)) {
        item.status = InspectButtonStatus.COMPLETED;
      } else {
        item.status = InspectButtonStatus.INCOMPLETE;
      }
    } else if (
      item.inspectResult == InspectButtonValue.CROSS ||
      item.inspectResult == InspectButtonValue.TRIANGLE
    ) {
      if (item.workBuhinSelected === STATUS_SELECT_WORK_BUHIN.FakeDone) {
        item.status = InspectButtonStatus.COMPLETED;
      } else if (
        item.seibiList &&
        ((item.seibiList.length == 0 && item.manualSeibiList.length == 0) ||
          item.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Done) &&
        this.checkInspectValue(item)
      ) {
        item.status = InspectButtonStatus.COMPLETED;
      } else {
        /** 2021-12-01 sh #7587 change checking of seibiIds. [START] */
        // item.status = InspectButtonStatus.INCOMPLETE;
        /** ○から△や×に変わったときに、他で選択済みの重複する整備が有ったら、fakeDoneにしておく。 */
        if (item.workBuhinSelected === STATUS_SELECT_WORK_BUHIN.Initial) {
          const filteredSeibi = item.seibiList.filter((e: any) => {
            return e.buhinSelected == STATUS_SELECT_WORK_BUHIN.Done
          });
          if (filteredSeibi.length>0) {
            item.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.FakeDone;
            item.status = InspectButtonStatus.COMPLETED;
          } else {
            item.status = InspectButtonStatus.INCOMPLETE;
          }
        } else {
          item.status = InspectButtonStatus.INCOMPLETE;
        }
        /** 2021-12-01 sh #7587 change checking of seibiIds. [END] */
      }
    } else {
      if (item.workBuhinSelected > 0) {
        item.status = InspectButtonStatus.INCOMPLETE;
      } else if (
        item.inspectValueViewType != INSPECT_VALUE_VIEW_TYPE.SUNFLARE &&
        item.inspectValueViewType > 0 &&
        this.checkInspectValue(item)
      ) {
        item.status = InspectButtonStatus.INCOMPLETE;
      } else {
        item.status = InspectButtonStatus.NONE;
      }
    }
  }

  changeStatusRecommendSeibi(item: InspectRecommendSubItem) {
    if (item.inspectResult == InspectButtonValue.CIRCLE) {
      item.status = InspectButtonStatus.COMPLETED;
    } else if (
      item.inspectResult == InspectButtonValue.CROSS ||
      item.inspectResult == InspectButtonValue.TRIANGLE
    ) {
      if (item.buhinSelected > 0) {
        item.status = InspectButtonStatus.COMPLETED;
      } else {
        item.status = InspectButtonStatus.INCOMPLETE;
      }
    } else {
      if (item.buhinSelected > 0) {
        item.status = InspectButtonStatus.INCOMPLETE;
      } else {
        item.status = InspectButtonStatus.NONE;
      }
    }
  }

  changeStatusRecommendSeibi2(item: InspectRecommendSubItem) { // Recommend
    if (item.isInspectDuplicate) {
      item.osusumeIsShow = 1;
    }
    // if (item.inspectResult == InspectButtonValue.CROSS ||
    //   item.inspectResult == InspectButtonValue.TRIANGLE ||
    //   item.inspectResult == InspectButtonValue.CIRCLE) {
      if (!item.osusumeIsShow) {
        // item.status = InspectButtonStatus.INCOMPLETE;
        item.status = InspectButtonStatus.NONE;
      } else {
        if (item.buhinSelected > 0) {
          item.status = InspectButtonStatus.COMPLETED;
        } else {
          item.status = InspectButtonStatus.INCOMPLETE;
        }
      }
    // } else {
    //   if (item.buhinSelected > 0) {
    //     item.status = InspectButtonStatus.INCOMPLETE;
    //   } else {
    //     item.status = InspectButtonStatus.NONE;
    //   }
    // }
  }

  checkInspectValue(item: any) {
    if (
      item.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SUNFLARE ||
      item.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BASIC_OBD ||
      item.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SYNC_OBD ||
      item.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.GROUND_CLR
    ) {
      return true;
    } else if (
      item.inspectValueViewType > 0 &&
      (item.inspectValueList == null ||
        (item.inspectValueList &&
          (item.inspectValueList.length == 0 ||
            item.inspectValueList.every(
              (val: InspectValueItem) => val.inspectValue == null && (val.inspectValueStr == null || val.inspectValueStr == '')
            )))
      )
    ) {
      return false;
    }
    return true;
  }

  checkDisableSaveInspectValue(list: InspectValueItem[], viewType: number = 0) {
    if (list.length > 0) {
      if (viewType == INSPECT_VALUE_VIEW_TYPE.TIRE) {
        const filterNull = list.filter(val => val.inspectValue == null);
        return filterNull.length > 0;
      } else {
        return list.every(val => val.inspectValue == null);
      }
    }
    return false;
  }

  isDisabled(item: InspectItem) {
    return item.inspectResult == InspectButtonValue.CIRCLE;
  }

  isComplete(item: any) {
    return item.status == InspectButtonStatus.COMPLETED;
  }

  isIncomplete(item: any) {
    return item.status == InspectButtonStatus.INCOMPLETE;
  }

  isStatusNone(item: InspectItem) {
    return item.status == InspectButtonStatus.NONE;
  }

  getRegisterStatus(arrCate: any) {
    let cateComplete = arrCate.filter(
      (cate: any) => cate.status == InspectButtonStatus.COMPLETED
    );
    let status = NAVIGATION_STATUS.REGISTER_NOTCOMPLETE;
    if (cateComplete.length == arrCate.length) {
      status = NAVIGATION_STATUS.REGISTER;
    }
    return status;
  }

  getRegisterStatusMD15(data: any) {
    const arrKey = Object.keys(data);
    arrKey.forEach(ke => { });
    let inspectList = data.filter(
      (item: any) => item.inspectResult == InspectButtonValue.CROSS ||
        item.inspectResult == InspectButtonValue.TRIANGLE
    );
    let dataComplete = inspectList.filter(
      (item: any) =>
        item.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Done ||
        item.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.NoNeed
    );
    let status = NAVIGATION_STATUS.REGISTER_NOTCOMPLETE;
    if (dataComplete.length == inspectList.length) {
      status = NAVIGATION_STATUS.REGISTER;
    }
    return status;
  }

  getSeibiListByResult(seibiList: any, manualList: any) {
    let listCross = [];
    let listTriangle = [];
    let listNoResult = [];
    let listManualCross = [];
    let listManualTriangle = [];
    let listManualNoResult = [];
    let listManualFree = [];
    let listHigh = [];
    let listMid = [];
    let listLow = [];
    let listNopriority = [];
    let arrType = [0, 1, 3];
    let arrTypeRec = [2, 4];
    if (seibiList && seibiList.length > 0) {

      //しない、後日を外す
      seibiList = seibiList.filter(
        (seibi: any) =>
          seibi.inspectSeibi.doTenken == 1
      );

      if(seibiList.length > 0) {

        listCross = this.filterByInspectResult(
          seibiList,
          InspectButtonValue.CROSS,
          arrType
        );

        listTriangle = this.filterByInspectResult(
          seibiList,
          InspectButtonValue.TRIANGLE,
          arrType
        );
        listNoResult = this.filterByInspectResult(seibiList, 0);
        listHigh = this.filterByInspectResult(seibiList, InspectButtonValue.CROSS, arrTypeRec);
        listMid = this.filterByInspectResult(seibiList, InspectButtonValue.TRIANGLE, arrTypeRec);
        listLow = this.filterByInspectResult(seibiList, InspectButtonValue.CIRCLE, arrTypeRec);
        listNopriority = this.filterByInspectResult(seibiList, InspectButtonValue.NOPRIORITY, arrTypeRec);
      }
    }

    if (manualList && manualList.length > 0) {

      //しない、後日を外す
      manualList = manualList.filter(
        (seibi: any) =>
          seibi.inspectSeibi.doTenken == 1
      );

      if(manualList.length > 0) {

        listManualCross = this.filterByInspectResult(
          manualList,
          InspectButtonValue.CROSS,
          null,
          true
        );
        listManualTriangle = this.filterByInspectResult(
          manualList,
          InspectButtonValue.TRIANGLE,
          null,
          true
        );
        listManualFree = this.filterByInspectResult(
          manualList,
          InspectButtonValue.FREE,
          null,
          true
        );
        listManualNoResult = this.filterByInspectResult(manualList, 0, null, true);
      }
    }
    listCross = listCross.concat(listManualCross);
    listTriangle = listTriangle
      .concat(listManualTriangle)
      .concat(listNoResult)
      .concat(listManualNoResult);
    return [listCross, listTriangle, listHigh, listMid, listLow, listNopriority, listManualFree];
  }

  getinspectListByResult(inspectList: any) {
    if (inspectList && inspectList.length > 0) {
      let list: any = [];
      list.push(
        this.filterByInspectResult(inspectList, InspectButtonValue.CROSS)
      );
      let listTriangle = this.filterByInspectResult(
        inspectList,
        InspectButtonValue.TRIANGLE
      );
      // let listNoResult = this.filterByInspectResult(inspectList, 0);
      // if (listNoResult.length > 0) {
      //   listTriangle = listTriangle.concat(listNoResult);
      // }
      list.push(listTriangle);
      return list;
    }
    return [];
  }

  filterByInspectResult(seibiList: any, inspectResult: number, inspecType: any = null, isManual: boolean = false) {
    let allowNull = false;
    if (inspectResult == 0) {
      allowNull = true;
    }
    if (seibiList[0].inspectSeibi) {
      if (!isManual) {
        if (inspecType == null) {
          seibiList = seibiList.filter(
            (seibi: any) =>
              seibi.inspectSeibi.sknInspectType <= 1
          );
        } else {
          seibiList = seibiList.filter(
            (seibi: any) =>
              inspecType.indexOf(seibi.inspectSeibi.sknInspectType) > -1
          );
        }
      }
      return seibiList.filter(
        (seibi: any) =>
          seibi.inspectSeibi.inspectResult == inspectResult ||
          (allowNull && !seibi.inspectSeibi.inspectResult)
      );
    } else {
      return seibiList.filter(
        (seibi: any) => seibi.inspectResult == inspectResult
      );
    }
  }

  inspectResClassTitle(index: number, mode: number = 0) {
    let result;
    if (mode == 2) {
      if (index == 2) {
        result = InspectButtonValue.CROSS;
      } else if (index == 3) {
        result = InspectButtonValue.TRIANGLE;
      } else if (index == 4){
        result = InspectButtonValue.CIRCLE;
      } else if (index == 5){
        result = InspectButtonValue.NOPRIORITY;
      } else {
        result = InspectButtonValue.FREE;
      }
      //NOPRIORITY と FREEで挙動を返るときはinspectResClass(result, 2)にする
      //const resClass = this.inspectResClass(result, 2);
      //return resClass ?  "d_ib m3r m3l "  + resClass : "d_ib m5r m5l";
    }else{
      if (index == 0) {
        result = InspectButtonValue.CROSS;
      } else {
        result = InspectButtonValue.TRIANGLE;
      }
    }
    const resClass = this.inspectResClass(result, 0);
    return resClass ?  resClass : "d_ib m5r m5l";
  }

  inspectResClass(result: number, inspectType: number) {
    if (inspectType == 2 || inspectType == 4) {
    //   if (result == InspectButtonValue.CROSS) {
    //     return "high";
    //   } else if (result == InspectButtonValue.TRIANGLE) {
    //     return "mid";
    //   } else if (result == InspectButtonValue.CIRCLE) {
    //     return "low";
    //   }
      if (result == InspectButtonValue.FREE) {
        return "free";
      }
      return "";
    } else {
      if (result == InspectButtonValue.CROSS) {
        return "cross el-icon-close";
      } else if (result == InspectButtonValue.TRIANGLE) {
        return "triangle";
      }
    }
  }

  setPassAllCategory(
    index: number,
    activeIndex: number,
    listButtonGroup: ButtonInspectGroup[],
    cate: any
  ) {
    if (index == activeIndex && cate.status != InspectButtonStatus.COMPLETED) {
      for (let i = 0; i < listButtonGroup.length; i++) {
        let buttongroup: any = listButtonGroup[i];
        const isChange = (buttongroup as any).setActive({
          isActive: true,
          value: InspectButtonValue.CIRCLE,
          isAll: true
        });
      }
    }
  }

  changeWorkStatus(inspect: InspectDescriptions) {
    const seibiSelectedBuhin = inspect.seibiList.filter(
      inspect => inspect.buhinSelected > STATUS_SELECT_WORK_BUHIN.Initial
    );
    const seibiManual = inspect.manualSeibiList.filter(
      inspect => inspect.buhinSelected > STATUS_SELECT_WORK_BUHIN.Initial
    );
    if (seibiSelectedBuhin.length == 0 && seibiManual.length == 0) {
      inspect.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
    }
  }

  autoSetDuplicateSeibi(
    data: InspectDescriptions[],
    seibi: Work,
    callback?: any
  ) {
    data.forEach((inspect, i) => {
      const listDup = inspect.seibiList.filter(
        item => item.seibiDetailId == seibi.seibiDetailId && item.seibiId == seibi.seibiId && !item.ignoreSeibi
      );
      listDup.forEach(item => {
        item.buhinList = seibi.buhinList;
        item.manualBuhinList = seibi.manualBuhinList;
        if (seibi.buhinSelected == STATUS_SELECT_WORK_BUHIN.Initial) {
          item.disabledSave = false;
          item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Initial;
          this.changeWorkStatus(inspect);
        } else {
          seibi.ignoreSeibi = true;
          item.disabledSave = true;
          item.buhinSelected = STATUS_SELECT_WORK_BUHIN.Done;
          if (inspect.workBuhinSelected == STATUS_SELECT_WORK_BUHIN.Initial) {
            // inspect.workBuhinSelected = STATUS_SELECT_WORK_BUHIN.FakeDone;
            data[i].workBuhinSelected = STATUS_SELECT_WORK_BUHIN.FakeDone;
          }
        }
        const oldStatus = inspect.status;
        this.changeStatus(inspect);
        if (
          callback &&
          oldStatus != InspectButtonStatus.COMPLETED &&
          inspect.status == InspectButtonStatus.COMPLETED
        ) {
          setTimeout(() => {
            callback(inspect, i);
          }, 700);
        }
        // console.log("autoSetDuplicateSeibi", inspect, item);
      });
    });
  }

  autoSetInspectValueSameCommentId(
    inspectCateList: any[],
    inspectItem: InspectDescriptions,
    callback: any
  ) {
    if (inspectItem.sknInspectCommentId != null) {
      inspectCateList.forEach(cate => {
      	if (!cate.osusume) {
        cate.subItems.forEach((subItem: any, i: number) => {
          const sameInspectIndex = subItem.inspectDescriptions.findIndex(
            (inspect: any) =>
              inspect.sknInspectCommentId == inspectItem.sknInspectCommentId &&
              inspect.sknInspectDescriptionId !=
              inspectItem.sknInspectDescriptionId
          );
          if (sameInspectIndex > -1) {
            let sameInspect = subItem.inspectDescriptions[sameInspectIndex];
            sameInspect.inspectValueList = deepCopy(
              inspectItem.inspectValueList
            );
            this.changeStatus(sameInspect);
            callback(sameInspect, i, sameInspectIndex);
          }
        });
      	}
      });
    }
  }

  autoSetSameRecommendSeibi(
    data: InspectRecommendCategory[],
    seibi: InspectRecommendSubItem
  ) {
    if (
      seibi.buhinSelected == STATUS_SELECT_WORK_BUHIN.Done ||
      seibi.inspectResult > 0
    ) {
      data.forEach(recCate => {
        const recSeibiList = recCate.subItems.filter(
          recSeibi =>
            recSeibi.sknInspectSeibiDetailId == seibi.sknInspectSeibiDetailId &&
            recSeibi.sknRecommendInspecSeibiId !=
            seibi.sknRecommendInspecSeibiId
        );
        if (recSeibiList.length > 0) {
          recSeibiList.forEach(recSeibi => {
            recSeibi.inspectResult = seibi.inspectResult;
            recSeibi.buhinSelected = seibi.buhinSelected;
            recSeibi.isInspectDuplicate = 1;
          });
        }
      });
    }
  }

  setButtonAfterInputValue(
    inspect: InspectDescriptions,
    btnIndex: number,
    buttonGroupList: ButtonInspectGroup[],
    carSelection?: CarSelectData
  ) {
    let setCheck = inspect.inspectValueList ? inspect.inspectValueList.length > 0 ? inspect.inspectValueList.filter(data => data.inspectValue != null): false: false;
    if (setCheck && setCheck.length > 0) {
    // if (inspect.inspectResult == 0) {
    let isFrontTire = false;
    if (inspect.inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE &&
      inspect.sknInspectDescriptionNm.lastIndexOf("ﾌﾛﾝ") > -1) {
      isFrontTire = true;
    }
    let inspectResult = this.getInspectResultByInspectValue(
      inspect.inspectValueViewType,
      inspect.inspectValueList,
      carSelection,
      isFrontTire
    );
    if (inspectResult != 0) {
      inspect.inspectResult = inspectResult;
      if (btnIndex != -1) {
        let buttongroup: any = buttonGroupList[btnIndex] as ButtonInspectGroup;
        if (buttongroup) {
          buttongroup.setActive({
            isActive: true,
            value: inspectResult,
            isAll: false
          });
        }
      }
    }
    // }
    }
  }

  transformHibiToResult(hibi: any) {
    if (hibi) {
      hibi = parseInt(hibi);
      if (hibi > 3){
        hibi = 3;
      }
    }
    return hibi;
  }

  checkHibi(carSelection: CarSelectData, insectResult: number, isFrontTire: boolean) {
    if (isFrontTire) {
      if (this.transformHibiToResult(carSelection.fLeftTireHibi) == insectResult ||
      this.transformHibiToResult(carSelection.fRightTireHibi) == insectResult) {
        return insectResult;
      }
    } else {
      if (this.transformHibiToResult(carSelection.rRightTireHibi) == insectResult ||
      this.transformHibiToResult(carSelection.rLeftTireHibi) == insectResult) {
        return insectResult;
      }
    }
    return 0;
  }

  getInspectResultByInspectValue(
    inspectValueViewType: number,
    listInspectValue: any,
    carSelection?: CarSelectData,
    isFrontTire: boolean = false
  ) {
    if (inspectValueViewType && listInspectValue.length !== 0) {
      let inspectValue: number[] = listInspectValue.map((val: any) =>
        val.inspectValue ? val.inspectValue : 0
      );
      if (inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BATTERY) {
        //Battery
        if (inspectValue[0] <= 12.0) {
          return InspectButtonValue.CROSS;
        } else if (inspectValue[0] >= 12.1 && inspectValue[0] <= 12.5) {
          return InspectButtonValue.TRIANGLE;
        }
        return InspectButtonValue.CIRCLE;
      } else if (inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.TIRE) {
        //Tire
        let valHibi = 0;
        if (carSelection) {
          valHibi = this.checkHibi(carSelection, InspectButtonValue.CROSS, isFrontTire);
          if (valHibi === InspectButtonValue.CROSS) {
            return InspectButtonValue.CROSS;
          } else {
            valHibi = this.checkHibi(carSelection, InspectButtonValue.TRIANGLE, isFrontTire);
            if (valHibi === 0) {
              valHibi = this.checkHibi(carSelection, InspectButtonValue.CIRCLE, isFrontTire);
            }
          }
        }
        if (isFrontTire) {
          inspectValue = inspectValue.slice(0, 2);
        } else {
          inspectValue = inspectValue.slice(3);
        }
        let isCross: any[] = inspectValue.filter(data => data <= 2.5);
        if (isCross.length !== 0) {
          return InspectButtonValue.CROSS;
        }
        let isTriangle: any[] = inspectValue.filter(
          data => data >= 2.6 && data <= 4.0
        );
        if (isTriangle.length !== 0) {
          return InspectButtonValue.TRIANGLE;
        }
        if (valHibi === InspectButtonValue.TRIANGLE) {
          return InspectButtonValue.TRIANGLE;
        }
        return InspectButtonValue.CIRCLE;
      } else if (inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SIDE_SLIP) {
        //Side slip
        if (inspectValue[0] <= 5) {
          return InspectButtonValue.CIRCLE;
        }
        return InspectButtonValue.CROSS;
      } else if (inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BRAKE) {
        //brake pad
        let isCross: any[] = inspectValue.filter((data: number) => data <= 4);
        if (isCross.length !== 0) {
          return InspectButtonValue.CROSS;
        }
        let isTriangle: any[] = inspectValue.filter(
          (data: number) => data >= 4.1 && data <= 5
        );
        if (isTriangle.length !== 0) {
          return InspectButtonValue.TRIANGLE;
        }
        return InspectButtonValue.CIRCLE;
      } else if (inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.SPEED) {
        //Speed
        if (inspectValue[0] >= 31 && inspectValue[0] <= 42.5) {
          return InspectButtonValue.CIRCLE;
        }
        return InspectButtonValue.CROSS;
      } else if (inspectValueViewType == INSPECT_VALUE_VIEW_TYPE.BRAKE_REAR) {
        //brake shoe
        let isCross: any[] = inspectValue.filter(data => data <= 2);
        if (isCross.length !== 0) {
          return InspectButtonValue.CROSS;
        }
        let isTriangle: any[] = inspectValue.filter(
          data => data >= 2.1 && data <= 3
        );
        if (isTriangle.length !== 0) {
          return InspectButtonValue.TRIANGLE;
        }
        return InspectButtonValue.CIRCLE;
      } else if (inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.BOOTS) {
        if (inspectValue[0] >= 3) {
          return InspectButtonValue.TRIANGLE;
        } else {
          return inspectValue[0];
        }
      } else if (inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.SUNFLARE) {
        if (inspectValue[0] === 1 || inspectValue[0] === 2) {
          return InspectButtonValue.CIRCLE;
        }
      }
    }
    return 0;
  }

  filterWorkOrder(items: any) {
    return items.filter(
      (seibi: any, index: number, self: any) => {
        const i = self.findIndex(
          (e: any) =>
            (e.inspectSeibi.sknUketsukeInspectSeibiId &&
              e.inspectSeibi.sknUketsukeInspectSeibiId ===
              seibi.inspectSeibi.sknUketsukeInspectSeibiId) ||
            (e.inspectSeibi.sknUketsukeManualSeibiId &&
              e.inspectSeibi.sknUketsukeManualSeibiId ===
              seibi.inspectSeibi.sknUketsukeManualSeibiId)
        );
        if (i != index) {
          if (seibi.inspectSeibi.seibiJoukyou === 1) {
            self[i].inspectSeibi = self[index].inspectSeibi;
            self[i].seibiStaff = self[index].seibiStaff;
            self[i].otherStaff = self[index].otherStaff;
          }
          return false;
        }
        return true;
      }
    );
  }

  resetHibi(val: number, index: number, carData: any) {
    const key = ["fLeftTireHibi", "fRightTireHibi", "rLeftTireHibi", "rRightTireHibi"];
    if (carData[key[index]] === val) {
      carData[key[index]] = 0;
    }
  }

  findInspectionByValueViewType(
    subItems: InspectGenshaSubItem[],
    inspectValueViewType: number
  ) {
    const promise = new Promise((resolve, reject) => {
      let viewType: any = [];
      if (inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.BOOTS) {
        viewType = [inspectValueViewType];
      } else if (inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.BRAKE ||
        inspectValueViewType === INSPECT_VALUE_VIEW_TYPE.BRAKE_REAR) {
        viewType = [INSPECT_VALUE_VIEW_TYPE.BRAKE_REAR, INSPECT_VALUE_VIEW_TYPE.BRAKE];
      }
      if (viewType.length > 0) {
        let list: any = [];
        let index: any = [];
        const promise = subItems.map((subItem, i) => {
          let list1 = subItem.inspectDescriptions.filter(
            inspect =>
              viewType.indexOf(inspect.inspectValueViewType) > -1
          );
          if (list1.length > 0) {
            list = [...list, ...list1];
            const listIndex = list1.map((e: any) => {
              const valLength = INSPECT_VALUE_LENGTH[e.inspectValueViewType];
              if (e.inspectValueList == null || (e.inspectValueList && e.inspectValueList.length < valLength)) {
                let list: InspectValueItem[] = [];
                let iStart = 0;
                let val = null;
                if (e.inspectValueList && e.inspectValueList.length > 0) {
                  iStart = e.inspectValueList.length;
                  list = deepCopy(e.inspectValueList);
                  val = e.inspectValueList[0].inspectValue;
                }
                for (let i = iStart; i < valLength; i++) {
                  list.push({ branchId: i + 1, inspectValue: val });
                }
                e.inspectValueList = list;
              }
              return subItem.inspectDescriptions.findIndex((ins: any) => ins.sknInspectDescriptionId == e.sknInspectDescriptionId)
            });
            index.push({ i, listIndex })
          }
          return subItem;
        });
        Promise.all(promise).then(() => {
          resolve({ list, index });
        });
      } else {
        reject(null);
      }
    });
    return promise;
  }

  isNoSeibi(inspect: InspectDescriptions) {
    if (inspect.seibiList.length == 0 && inspect.manualSeibiList.length == 0) {
      return true;
    }
    return false;
  }

  getJizenRegisterStatus(arrCate: any) {
    let cateComplete: any[] = [];
    arrCate.forEach((cate: any) => {
      if (!cate.osusume) {
        if (cate.status == InspectButtonStatus.COMPLETED) cateComplete.push(cate);
      } else {
        let incompleteFlg = false;
        cate.recommend.forEach((subCate: any) => {
          if (subCate.status != InspectButtonStatus.COMPLETED) incompleteFlg = true;
        });
        if (!incompleteFlg) cateComplete.push(cate);
      }
    });
    let status = NAVIGATION_STATUS.REGISTER_NOTCOMPLETE;
    if (cateComplete.length == arrCate.length) {
      status = NAVIGATION_STATUS.REGISTER;
    }
    return status;
  }

  /** 2021-09-22 sh #7411 check seibi of recommend for jizen [START] */
  autoSetSameRecommendSeibi4Jizen(
    data: any[],
    inspectItem: InspectDescriptions,
    seibi: Work,
    isInspectDublicate: any
  ) {
    if (
      seibi.buhinSelected == STATUS_SELECT_WORK_BUHIN.Done ||
      inspectItem.inspectResult > 0
    ) {
      data.forEach(cate => {
        if (cate.osusume) {
          cate.recommend.forEach((recommend: any) => {
            if( recommend.subItems ){
              const recSeibiList = recommend.subItems.filter(
                (recSeibi: any) =>
                  recSeibi.sknInspectSeibiDetailId == seibi.seibiDetailId
              );
              if (recSeibiList.length > 0) {
                recSeibiList.forEach((recSeibi: any) => {
                  recSeibi.status = InspectButtonStatus.COMPLETED;
                  recSeibi.inspectResult = inspectItem.inspectResult;
                  recSeibi.buhinSelected = seibi.buhinSelected;
                  recSeibi.isInspectDuplicate = isInspectDublicate;
                  recSeibi.osusumeIsShow = isInspectDublicate;
                });
              }
            }
          });
        }
      });
    }
  }
  autoResetSameRecommendSeibi4Jizen(
    data: any[],
    inspectItem: InspectDescriptions
  ) {
    inspectItem.seibiList.forEach((seibi: Work) => {
      if (
        inspectItem.inspectResult > 0
      ) {
        data.forEach(cate => {
          if (cate.osusume) {
            cate.recommend.forEach((recommend: any) => {
              if( recommend.subItems ){
                const recSeibiList = recommend.subItems.filter(
                  (recSeibi: any) =>
                    recSeibi.sknInspectSeibiDetailId == seibi.seibiDetailId
                );
                if (recSeibiList.length > 0) {
                  recSeibiList.forEach((recSeibi: any) => {
                    recSeibi.status = InspectButtonStatus.NONE;
                    recSeibi.isInspectDuplicate = 0
                    recSeibi.osusumeIsShow = 0
                  });
                }
              }
            });
          }
        });
      }
    });
  }
  /** 2021-09-22 sh #7411 check seibi of recommend for jizen [END] */
}
